export const COLLAPSE_ANIMATION_TIMEOUT = 500;
